import React, { useContext, useEffect, useState } from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import useApiFunction from "../../api/useApiFunction";
import valueContext from "../../customHook/useContext";
import Modal from "../Shared/Modal";

function Meeting() {
  const { joinMemberToken } = useContext(valueContext);

  const token = joinMemberToken();

  const [data, setData] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState();
  const [imageData, setImageData] = useState([]);

  function handleChange(index) {
    setCurrentIndex(index);
  }
  const { formDataFunc } = useApiFunction();
  const navigate = useNavigate();
  async function getData() {
    const res = await formDataFunc(
      "member/get_all_meetings",
      JSON.stringify({}),
      "POST",
      token
    );
    if (res.status) {
      setData(res.msg);
    } else if (
      res.error &&
      (res.error === "ERROR_TOKEN_INVALID0" ||
        res.error === "ERROR_TOKEN_INVALID1" ||
        res.error === "user not registered" ||
        res.error === "ERROR_TOKEN_INVALID2" ||
        res.error === "ERROR_TOKEN_INVALID3" ||
        res.error === "unauthorized" ||
        res.error === "Your session has expierd Please login again 1" ||
        res.error === "Your session has expierd Please login again 2")
    ) {
      navigate("/login");
    } else if (res.error) {
      toast.warning(res.error, { autoClose: 2000 });
    } else {
      toast.warning(res.msg, {
        autoClose: 2000
      });
    }
  }
  useEffect(() => {
    getData();
  }, []);

  const renderSlides = imageData.map(image => (
    <div>
      <img
        src={
          image.includes("https")
            ? image
            : `https://cdn.anafton.com/core-twl/${image}`
        }
      />
      <p className="legend">
        {image.includes("https")
          ? image
          : `https://cdn.anafton.com/core-twl/${image}`}
      </p>
    </div>
  ));

  return (
    <>
      <div id="layout-wrapper">
        <div className="main-content">
          <div className="page-content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-12">
                  <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                    <h4 className="mb-sm-0 font-size-18">Meetings</h4>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-xl-12">
                  <div className="card">
                    <div className="card-body">
                      <div className="table-responsive">
                        <h4 className="card-title table-head">Meetings List</h4>

                        <div className="table-responsive table-line">
                          <table
                            className="table align-middle mb-0"
                            id="order-listing"
                          >
                            <thead>
                              <tr>
                                <th>#</th>
                                <th>Title</th>
                                <th>Date</th>
                                <th>Memo</th>
                                <th>Location</th>
                                <th>View Meeting pictures</th>
                              </tr>
                            </thead>
                            <tbody>
                              {data && data.length > 0 ? (
                                data.map((details, i) => {
                                  return (
                                    <tr>
                                      <th scope="row">{i + 1}</th>
                                      <td>{details.title}</td>
                                      <td>{details.date}</td>
                                      <td>{details.memo}</td>
                                      <td>{details.location}</td>
                                      <td>
                                        <button
                                          type="button"
                                          className="btn btn-success btn-sm"
                                          onClick={() => {
                                            setIsOpen(true);
                                            setImageData(
                                              details.images
                                                ? details.images
                                                : [
                                                    "https://upload.wikimedia.org/wikipedia/commons/1/14/No_Image_Available.jpg?20200913095930"
                                                  ]
                                            );
                                          }}
                                        >
                                          View Pictures
                                        </button>
                                      </td>
                                    </tr>
                                  );
                                })
                              ) : (
                                <p>NO DATA</p>
                              )}
                            </tbody>
                          </table>
                        </div>
                        {isOpen ? (
                          <Modal show={isOpen} close={setIsOpen}>
                            <Carousel
                              showArrows={true}
                              autoPlay={true}
                              infiniteLoop={true}
                              selectedItem={imageData[currentIndex]}
                              onChange={handleChange}
                              className="carousel-container"
                            >
                              {renderSlides}
                            </Carousel>
                          </Modal>
                        ) : (
                          <></>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Meeting;
